if(!customElements.get('localization-form')){
    class LocalizationForm extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.buttonLocale = this.querySelector(".button-locale");
            this.buttonLocale.addEventListener("click", this.toggleLocalizationInput.bind(this));

            this.localeOptionWrapper = this.querySelector(".localization-options");
            this.localeOptionList = this.querySelectorAll('.localization-options a');
            this.localeOptionList.forEach(item => {
                item.addEventListener('click', this.clickOnOption.bind(this));
                item.addEventListener('keydown', this.keydownOnOption.bind(this));
            });

            document.addEventListener('click', this.closeOnclickOutsideOptions.bind(this));

            // set localeOptionWrapper position
            const localeOptionPos = isElementOutOfView(this.localeOptionWrapper);
            if(localeOptionPos.includes("bottom")){
                this.localeOptionWrapper.classList.remove("top-full");
                this.localeOptionWrapper.classList.add("bottom-full");
            }
            if(localeOptionPos.includes("right")){
                this.localeOptionWrapper.classList.remove("left-0");
                this.localeOptionWrapper.classList.add("right-0");
            }

            this.onScrollUtilityBarUnsubscriber = PubSub.subscribe(PubSub.events.utilityBarScrolled, this.handleUtilityBarsScroll.bind(this));
        }

        disconnectedCallback(){
            document.removeEventListener("click", this.closeOnclickOutsideOptions.bind(this));

            if(this.onScrollUtilityBarUnsubscriber){
                this.onScrollUtilityBarUnsubscriber();
            }
        }

        handleUtilityBarsScroll(){
            this.closeOptions();
        }

        clickOnOption(e){
            e.preventDefault();
            const option = e.currentTarget;
            const form = option.closest('form');
            const input = form? form.querySelector('.input-locale') : null;
            if(input && form){
                input.value = option.dataset.value;
                form.submit();
            }
        }

        keydownOnOption(e){
            if(!this.localeOptionWrapper) return;

            if(e.key == 'ArrowDown'){
                e.preventDefault();
                const focusableElements = this.localeOptionList;
                const currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                const nextIndex = currentIndex === focusableElements.length - 1? currentIndex : currentIndex + 1;
                focusableElements[nextIndex].focus();
            }else if(e.key === 'ArrowUp'){
                e.preventDefault();
                const focusableElements = this.localeOptionList;
                const currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                const nextIndex = currentIndex === 0? 0 : currentIndex - 1;
                focusableElements[nextIndex].focus();
            }else if(e.key === 'Escape'){
                this.localeOptionWrapper.setAttribute('data-hidden', 'true');
                this.localeOptionWrapper.setAttribute('inert', '');
                this.classList.remove('active');
            }else if(e.key === 'Tab'){
                const focusableElements = this.localeOptionList;
                const currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                const nextIndex = currentIndex + 1;
                if(!focusableElements[nextIndex]){
                    this.localeOptionWrapper.setAttribute('data-hidden', 'true');
                    this.localeOptionWrapper.setAttribute('inert', '');
                    this.classList.remove('active');
                }
            }
        }

        toggleLocalizationInput(e){
            if(!this.localeOptionWrapper) return;
            e.stopPropagation();

            const item = e.currentTarget;
            if(this.localeOptionWrapper.getAttribute('data-hidden') === 'false'){
                this.localeOptionWrapper.setAttribute('data-hidden', 'true');
                this.localeOptionWrapper.setAttribute('inert', '');
                this.classList.remove('active');

                item.removeEventListener('keydown', this.keydownOnButton.bind(this));
            }else{ // open
                this.localeOptionWrapper.setAttribute('data-hidden', 'false');
                this.classList.add('active');
                this.localeOptionWrapper.removeAttribute('inert');

                item.addEventListener('keydown', this.keydownOnButton.bind(this));
            }

            // close other options
            document.querySelectorAll('localization-form .localization-options').forEach(item => {
                if(item !== this.localeOptionWrapper){
                    item.setAttribute('data-hidden', 'true');
                    item.setAttribute('inert', '');
                    const form = item.closest("localization-form");
                    if(form){
                        form.classList.remove('active');
                    }
                }
            });
        }

        closeOnclickOutsideOptions(e){
            if(this.localeOptionWrapper.getAttribute('data-hidden') === 'true') return;
            const clickedItem = e.target;

            if(clickedItem.closest('.localization-form') !== this){
                this.closeOptions();
            }
        }

        keydownOnButton(e){
            if(!this.localeOptionWrapper) return;

            if(e.key === 'ArrowDown' || e.key === 'Tab'){
                const focusableElements = this.localeOptionList;
                const nextIndex = 0;
                focusableElements[nextIndex].focus();
            }else if(e.key === 'Escape'){
                this.closeOptions();
            }
        }

        closeOptions(){
            this.localeOptionWrapper.setAttribute('data-hidden', 'true');
            this.localeOptionWrapper.setAttribute('inert', '');
            this.classList.remove('active');

            document.removeEventListener('click', this.closeOnclickOutsideOptions.bind(this));
            this.buttonLocale.removeEventListener('keydown', this.keydownOnButton.bind(this));
        }
    }

    customElements.define('localization-form', LocalizationForm);
}